module.exports = __webpack_public_path__ + "img/img.3994e1b1.png";